<div class="widget-pdf px-3">
    <div class="row justify-content-center">
        <div class="w-pdf position-relative" *ngFor="let data of dataWidgetPdf">
            <a class="d-block" (click)="showModal(data)">
                <img class="w-100" src="../../../assets/images/icon/pdf-icon.svg" alt="">
                <div class="info">
                    <div class="title">
                        <h6>{{ data.title }}</h6>
                        <small *ngIf="!data.description">{{ data.description }}</small>
                    </div>
                    <p class="pdf">PDF</p>
                </div>
            </a>
        </div>
    </div>
    <!-- modal download -->
    <div bsModal 
        *ngIf="isModalShown" 
        [config]="{ show: true }" 
        (onHidden)="onHidden()" 
        #modal="bs-modal" 
        class="modal fade modal-pdf" 
        tabindex="-1" 
        role="dialog" 
        aria-labelledby="dialog-sizes-name2">
        <div class="modal-dialog d-flex align-items-center h-100 my-0 py-4">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 id="dialog-sizes-name2" class="modal-title pull-left">Please fill the form to download this document</h5>
                    <button type="button" class="close pull-right" aria-label="Close" (click)="modal.hide()">
                        <svg width="19" height="19" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M21 2L2 21" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M2 2L21 21" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>                        
                    </button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-9 mx-auto text-center">
                            <form #pdfForm="ngForm" (ngSubmit)="onSubmit(pdfForm)" novalidate>
                                <div class="form-group">
                                    <input type="hidden" 
                                            #file_id="ngModel"
                                            name="file_id" 
                                            [ngModel]="dataFile.id">
                                    <input type="text" 
                                            class="form-control"
                                            placeholder="Name"
                                            required 
                                            #name="ngModel"
                                            [class.is-invalid]="name.invalid && name.touched"
                                            name="name" 
                                            ngModel>
                                    <small class="text-danger" 
                                        [class.d-none]="name.valid || name.untouched">
                                        Name is required
                                    </small>
                                </div>
                                <div class="form-group">
                                    <input type="email" 
                                            class="form-control"
                                            placeholder="Email Address"
                                            required 
                                            email
                                            #email="ngModel"
                                            [class.is-invalid]="email.invalid && email.touched"
                                            name="email" 
                                            ngModel>
                                    <small class="text-danger" 
                                        [class.d-none]="email.valid || email.untouched">
                                        Email Address "@" is required
                                    </small>
                                </div>
                                <button type="submit" class="btn red-btn mt-4 mb-3">Download</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
